module.exports = __webpack_public_path__ + "static/img/jxpxImg.3a85573.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jxpxImg.png
// module id = MKlN
// module chunks = 2